import { http } from "@/utils/request";
import type {
  CommoditiesResponse,
  GetCommoditiesParams,
  Commodity,
} from "@/types/commodities";

export const commodityService = {
  // 获取商品列表--待更新接口和参数
  getCommodities: async (
    params: GetCommoditiesParams
  ): Promise<CommoditiesResponse> => {
    return http.get<CommoditiesResponse>("/product/list", params);
  },

  // 更新商品状态--待更新接口和参数
  updateCommodityStatus: async ({
    id,
    ...params
  }: Commodity): Promise<void> => {
    return http.put(`/product/${id}`, params);
  },

  // 创建商品--待更新接口和参数
  createCommodity: async (params: Commodity): Promise<void> => {
    return http.post(`/product`, params);
  },
};
